import SimpleParallax from "simple-parallax-js/vanilla";




document.addEventListener("DOMContentLoaded", () => {
    const filters = document.querySelectorAll(".work__filters-item");
    const wrapper = document.querySelector(".work__wrapper");
    const modalFilterMob = document.querySelector(".work__filters-wrap");
    const closeFilterMob = document.querySelector(".work__filters .close");
    const exploreFilterMob = document.querySelector(".explore");
    const openFilterMob = document.querySelector(".work__filters-title");
    const html = document.querySelector("html");

    filters.forEach(filter => {
        filter.addEventListener("click", async () => {

            filters.forEach(item => item.classList.remove("active"));
            filter.classList.add("active");

            const status = filter.dataset.filter;

            try {

                const response = await fetch(myajax.url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    body: new URLSearchParams({
                        action: "filter_works",
                        status
                    })
                });

                const html = await response.text();

                wrapper.innerHTML = html;
                AOS.refreshHard();
                var image = document.querySelectorAll('.work__img-wrapper, .next-project__media, .next-project__parallax img, .work-hero__inner div, .sticky-images__images a, .contact__img-inner, .about__img-inner, .full-image');
                new SimpleParallax(image, { delay: 1, scale: 1.1,  transition: 'cubic-bezier(0,0,0,1)' });

            } catch (error) {
                console.error(error);
            }
        });
    });

    exploreFilterMob.addEventListener('click', () => {
        modalFilterMob.classList.remove('open');
        html.style.overflow = '';
    })
    openFilterMob.addEventListener('click', () => {
        modalFilterMob.classList.add('open');
        html.style.overflow = 'hidden';
    });

    closeFilterMob.addEventListener('click', () => {
        modalFilterMob.classList.remove('open');
        html.style.overflow = '';
    });
});